<template>
  <v-card
    elevation="0"
    class="card ma-0 pa-0 d-flex justify-center align-center"
    :class="{ card__small: small }"
    :style="`min-height: ${cardHeight}`"
    :outlined="false"
  >
    <ImageMedia
      v-if="hasMediaObject"
      class="image-media"
      :class="{ 'image-media__small': small }"
      :src="mediaObject"
    />
    <div v-else class="d-flex ">
      <v-icon class="blue-grey--text text--darken-1" size="32">
        mdi-image-outline
      </v-icon>
    </div>
  </v-card>
</template>

<script>
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import _ from 'lodash'

export default {
  name: 'PsPrintImageMedia',

  components: {
    ImageMedia,
  },

  props: {
    mediaObject: {
      type: Object,
      required: true,
    },
    small: Boolean,
  },

  computed: {
    hasMediaObject() {
      return !_.isEmpty(this.mediaObject)
    },

    cardHeight() {
      return this.small ? '58px' : '116px'
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  border: 1px dotted $color-blue-grey-darken3;
  max-width: 160px;

  &__small {
    max-width: 68px;
  }
}

.image-media {
  height: 112px;
  max-width: 150px;
  object-fit: contain;

  &__small {
    height: 52px;
    max-width: 56px;
  }
}
</style>
